// @flow
import * as React from "react";
import Gettext from "./common/Gettext";
import { isIronTerminal } from "./utils";

export default () => {
  if (isIronTerminal()) {
    return "IronTerminal";
  }

  switch (process.env.REACT_APP_DEPLOY_TARGET) {
    case "siamoption":
      return <Gettext>SiamOption</Gettext>;
    case "irontrade":
      return <Gettext>IronTrade</Gettext>;
    default:
      return "Rosco Solutions LTD";
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectTitle.js